const isActiveElement = element =>
  element && element === document.activeElement;

export default isActiveElement;
